module.exports = __webpack_public_path__ + "static/Rotunda-eaaf78e2f69c2287f0caa34a1b9e1e67.jpg";